import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BLUE, createStyles, makeStyles, WHITE } from '@applyboard/ui-components';
export var useStyle = makeStyles(function (theme) {
  return createStyles({
    rootStyle: _defineProperty({}, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('sm'), {
      backgroundColor: WHITE,
      marginTop: "-".concat(theme.spacing(6), "px"),
      // this is in order to remove the margin from the top nav bar
      '& .MuiCard-root': {
        border: 'none'
      }
    }),
    columnContentStyle: _defineProperty({
      backgroundColor: BLUE[21]
    }, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('sm'), {
      backgroundColor: WHITE
    })
  });
});